import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import Blog from './pages/Blog';
import SavingsBlog from './pages/SavingsBlog';
import RetirementCalculator from './pages/RetirementCalculator';
import LoanCalculator from './pages/LoanCalculator';
import StudentLoanCalculator from './pages/StudentLoanCalculator';
import InvestmentCalculator from './pages/InvestmentCalculator';
import NetWorthCalculator from './pages/NetWorthCalculator';
import TakeHomeCalculator from './pages/TakeHomeCalculator';
import WithholdingCalculator from './pages/WithholdingCalculator';
import DocumentAnalysis from './pages/DocumentAnalysis';
import MilitaryCalculator from './pages/MilitaryCalculator';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/savings-blog" element={<SavingsBlog />} />
        <Route path="/retirement" element={<RetirementCalculator />} />
        <Route path="/loan" element={<LoanCalculator />} />
        <Route path="/student-loan" element={<StudentLoanCalculator />} />
        <Route path="/investment" element={<InvestmentCalculator />} />
        <Route path="/net-worth" element={<NetWorthCalculator />} />
        <Route path="/take-home" element={<TakeHomeCalculator />} />
        <Route path="/withholding" element={<WithholdingCalculator />} />
        <Route path="/documents" element={<DocumentAnalysis />} />
        <Route path="/military" element={<MilitaryCalculator />} />
      </Routes>
    </Router>
  </StrictMode>
);